import { format } from 'date-fns';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const QuarterCustomTick = (props: any) => {
  const { x, y, payload } = props;

  const date = new Date(payload.value);
  const quarter = format(date, 'Q');
  const year = format(date, 'yyyy');

  return (
    <g transform={`translate(${x},${y})`}>
      <text x={0} y={0} dy={16} textAnchor="middle" fill="#666">
        Q{quarter}
      </text>
      <text x={0} y={18} dy={16} textAnchor="middle" fill="#666">
        {year}
      </text>
    </g>
  );
};
